import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.imgurl)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: $setup.imgurl,
        target: "_blank"
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _cache[0] || (_cache[0] = _createTextVNode("Download"))
        ])
      ], 8, _hoisted_1))
    : ($setup.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Not Found"))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, "Loading..."))
}